<!--
 * @Author: LeeHuiXian
 * @version:
 * @Date: 2020-04-24 17:29:09
 * @LastEditors: LeeHuiXian
 * @LastEditTime: 2020-12-07 16:32:41
 * @FilePath: /wxweb-vue/Users/golden/Documents/WorkSpace/GdsWeb/goldenSalesMobile/src/views/SubmitOrder/index.vue
 * @Description: 提交订单
-->
<template>
  <div class='page-container'>
    <nav-bar title="提交订单" />
    <div class="goods-info-wrap">
      <van-image
        class="goods-img"
        :src="goodsInfo.imgUrl"
        fit="cover"
      />
      <div class="goods-info">
        <p class="goods-name">{{ goodsInfo.name }}</p>
        <p class="goods-price">￥<span>{{ goodsInfo.price }}</span></p>
      </div>
    </div>
    <div class="order-info">
      <van-cell title="有效期">
        <span>{{ goodsInfo.validTime }}</span>
      </van-cell>
      <van-cell title="数量">
        <van-stepper
          integer
          :value="goodsInfo.number"
          @change="onGoodsNumChange"
        />
      </van-cell>
      <van-cell title="总价">
        <span>￥{{ totalPrice }}</span>
      </van-cell>
      <van-cell title="手机号">
        <input
          type="tel"
          style="width:70%;"
          v-model="userPhone"
          placeholder="接收短信通知"
          @input="onPhoneChange"
          @blur="loseFocus"
        />
      </van-cell>
      <!-- <van-cell class="auth-input" title="验证码" v-if="!isWeChatClient">
        <input
          type="tel"
          style="width:120px;"
          v-model="authCode"
          placeholder="请输入验证码"
          @input="onAuthCodeChange"
          @blur="loseFocus"
        />
        <verify-code :phone="userPhone" @onGetSmsCode="onGetSmsCode" />
      </van-cell> -->
      <!-- <van-cell title="支付方式">
        <span>{{ payWayText }}</span>
      </van-cell> -->
    </div>
    <div class="fixed-btn">
      <van-button
        block
        :color="isVisable ? 'linear-gradient(to right, #FA9B00, #FBCA39)': 'linear-gradient(to right, #B5BBD0, #D7DDEA)'"
        @click="onSubmit"
      >
        提交订单
      </van-button>
    </div>
  </div>
</template>

<script>
// import VerifyCode from '@/components/VerifyCode/index'
import { mobileReg } from '@/utils/index'
import { submitOrder, getOrderDetail } from '@/api/order'
// import { getBrandWCPayRequest } from '@/utils/wxpay'
// import { wxPay } from '@/api/pay'
// import { login, getMsCode } from '@/api/user'
// import { getShouqianbaConfig } from '@/api/system'
import { sqbWxPay, sqbH5Pay } from '@/api/pay'

export default {
  // components: { VerifyCode },

  data() {
    return {
      goodsInfo: {},
      userPhone: '',
      authCode: '',
      distributorId: '',
      totalPrice: '',
      isVisable: false,
      payWay: 3, // 支付方式，3：微信，1：支付宝
      payWayText: '微信支付',
      userId: '', // 用户id，微信内置浏览器为openid，其他环境为系统的userId
      terminalSN: '', // 收钱吧终端序列号
      terminalSK: '', // 收钱吧终端秘钥
      isWeChatClient: true
    }
  },

  created() {
    // 缓存中获取当前的浏览器环境
    const storageBrowserType = this.$store.state.browserType;
    // console.log('缓存中的浏览器信息', storageBrowserType)
    const browserType = storageBrowserType ? JSON.parse(storageBrowserType) : {}
    if (browserType.shell === 'wechat') {
      this.userId = localStorage.getItem('OpenId')
    } else {
      this.isWeChatClient = false
    }
    // 缓存中获取商品信息
    const storageGoodsInfo = sessionStorage.getItem('goodsInfo')
    this.goodsInfo = storageGoodsInfo ? JSON.parse(storageGoodsInfo) : {}
    this.totalPrice = this.goodsInfo.price
    // 缓存中获取用户的手机号
    const stroageUserPhone = sessionStorage.getItem('userPhone')
    this.userPhone = stroageUserPhone
    // if (this.userPhone && this.isWeChatClient) {
    //   this.isVisable = true
    // }
    if (this.userPhone) {
      this.isVisable = true
    }


    // 获取收钱吧终端的序列号&秘钥
    // getShouqianbaConfig({tenantid: this.goodsInfo.tenantId})
    //   .then(res => {
    //     if (res) {
    //       this.terminalSN = res.SerialNumber
    //       this.terminalSK = res.Key
    //     }
    //   })

    // alert(localStorage.getItem('Ip'))
  },

  methods: {
    // 监听商品数量变化
    onGoodsNumChange(val) {
      this.goodsInfo.number = val
      this.totalPrice = (val * this.goodsInfo.price).toFixed(2)
    },

    // 监听手机号输入
    onPhoneChange() {
      if (mobileReg.test(this.userPhone)) {
        // if (this.isWeChatClient) {
        //   this.isVisable = true
        // }
        this.isVisable = true
        sessionStorage.setItem('userPhone', this.userPhone)
      }
    },

    // 监听验证码输入
    // onAuthCodeChange() {
    //   this.isVisable = true
    // },

    // 失去焦点时页面回滚顶部，避免ios上fixed定位导致元素位置偏移
    loseFocus() {
      window.scrollTo(0, 0);
    },

    // 获取短信验证码
    // onGetSmsCode() {
    //   getMsCode({phone: this.userPhone})
    //     .then(res => {
    //       if (res.success) {
    //         this.$toast('验证码已发送，请注意查收')
    //       } else {
    //         this.$toast(res.error)
    //       }
    //     })
    //     .catch(err => {
    //       console.log(err)
    //     })
    // },

    // 提交订单
    async onSubmit() {
      sessionStorage.setItem('pageBeforeLogin', 'submitOrder')
      const requestParams = {
        Items: [
          {
            DistributorId: localStorage.getItem('distributorId'),
            ProductId: this.goodsInfo.id,
            Quantity: this.goodsInfo.number
          }
        ],
        Phone: this.userPhone,
        VpnId: this.$store.state.vpnId,
      }
      // if (!this.isWeChatClient) {
      //   if (!this.authCode) {
      //     this.$toast('请先进行手机号的验证')
      //     return
      //   }
      //   let loginResult = await login({Phone: this.userPhone, SmsCode: this.authCode})
      //   console.log(loginResult)
      //   this.userId = loginResult.UserId
      // }
      const orderId = await submitOrder(requestParams)
      return;
      await this.$router.push({
        name: 'PayOrder',
        params: { id: orderId }
      })

      // const orderDetail = await getOrderDetail({query: {id: orderId}})
      // const sequenceId = orderDetail.Items[0].SequenceId
      // // 回调H5支付接口
      // this.onPay(sequenceId, orderId)
    },

    // 支付
    onPay(sequenceId, orderId) {
      // let returnUrl = location.href.split('#')[0] + '#/users/users-order'
      let returnUrl = location.href.split('#')[0] + '#/goods/order'
      let payRequest = ''
      let requestParams = {
        OutTradeNo: sequenceId,
        Subject: `金贵票务${orderId}`,
        // Fee: Number(this.totalPrice * 100),
        Fee: Number(0.01 * 100),
        Payway: this.payWay,
        // UserId: this.userId,
        ReturnUri: returnUrl,
        // ClientId: 2
      }
      if (this.isWeChatClient) {
        payRequest = sqbWxPay // 微信内置浏览器环境下，调用收钱吧公众号支付
      } else {
        payRequest = sqbH5Pay // 其他环境下调用收钱吧H5支付
        requestParams.SubPayway = 6
        requestParams.UserIp = localStorage.getItem('Ip')
      }
      payRequest(requestParams)
        .then(res => {
          if (res) {
            // 支付跳转链接
            if (this.isWeChatClient) {
              location.href = res
            } else if (res.wap_pay_request.h5_pay_redirect_url) {
              location.href = `${res.wap_pay_request.h5_pay_redirect_url}&redirect_url=${encodeURIComponent(returnUrl)}`
            }
          }
        })
        .catch(err => {
          // console.log(err)
        })

      // let $this = this
      // wxPay({
      //   OutTradeNo: sequenceId,
      //   Openid: localStorage.getItem('OpenId'),
      //   Body: `金贵票务${orderId}`,
      //   Fee: Number(this.totalPrice * 100)
      // })
      //   .then(res => {
      //     getBrandWCPayRequest(res, function() {
      //       // 成功回调
      //       $this.$router.push({
      //         name: 'Result',
      //         params: {
      //           type: 'pay',
      //           status: 'success',
      //           id: orderId
      //         }
      //       })
      //     }, function() {
      //       // 失败回调
      //       $this.$router.push({
      //         name: 'Result',
      //         params: {
      //           type: 'pay',
      //           status: 'fail',
      //           id: orderId
      //         }
      //       })
      //     })
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
    }
  }
}
</script>

<style lang='scss' scoped>
.page-container {
  box-sizing: border-box;
  padding: 0 40px;
  background: $blockBgColor;

  .goods-info-wrap {
    @include flex-box(flex-start, flex-start);
    margin-top: 40px;

    > .goods-img {
      flex: none;
      width: 160px;
      height: 160px;
      margin-right: 20px;
      border-radius: 16px;
      overflow: hidden;
    }

    > .goods-info {
      flex: 1;

      > .goods-name {
        width: 100%;
        margin-bottom: 10px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        line-height: 48px;
        font-size: 34px;
        font-weight: 500;
        color: $secondFontColor;
      }

      > .goods-price {
        line-height: 36px;
        font-size: 26px;
        font-weight: 600;
        color: #fe4600;

        > span {
          font-size: 40px;
        }
      }
    }
  }

  .order-info {
    &::v-deep .van-cell {
      padding: 15px 0;
      color: $baseFontColor;

      .van-cell__value {
        flex: 2;
        color: $secondFontColor;
        font-weight: 500;

        .van-stepper__input {
          margin: 0;
          width: 47px;
          background-color: #fff;
          border-top: 1px solid #d8d8d8;
          border-bottom: 1px solid #d8d8d8;
        }

        .van-stepper__minus,
        .van-stepper__plus {
          background-color: #fff;
          border: 1px solid #d8d8d8;
        }
      }
    }

    ::-webkit-input-placeholder {
      color: #ccc;
    }

    input {
      text-align: right;
      padding: 0 15px;
      width: 280px;
      border: 1px solid #d8d8d8;
      border-radius: 8px;
    }

    // .auth-input {
    //   >.van-cell__value {
    //     display: flex;
    //     align-items: center;
    //     justify-content: space-between;
    //   }

    //   .getAuthCode-btn {
    //     height:44px;
    //     font-size:32px;
    //     font-weight:500;
    //     color: rgba(251,202,57,1);
    //     line-height:44px;
    //     border: none;
    //   }
    // }
  }
}
</style>

